import { useContext } from 'react'

import DialogContext from '@providers/dialogProvider'

export default function useDialog() {
  const { PostData, updatePostData } = useContext(DialogContext)

  return { PostData, updatePostData }
}
